var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BasicButton',{attrs:{"title":"Статистика","appearance":"icon-only"},on:{"click":_vm.toggleAnalytics}},[_c('SvgIcon',{staticClass:"response-analytics-button__icon",attrs:{"icon":"stats","size":"24","source":_vm.$options.icons}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }